export const INTRACK_EVENT_PHONE = 'forgetPass-cellNumber';
export const INTRACK_EVENT_OTP = 'forgetPass-otp';
export const INTRACK_EVENT_PIN = 'forgetPass-new-pin';
export const INTRACK_EVENT_NID = 'forgetPass-national-id';
export const INTRACK_EVENT_NID_SUCCESS = 'forgetPass-national-id-success';
export const INTRACK_EVENT_NID_FAILURE = 'forgetPass-national-id-failure';
export const INTRACK_EVENT_BLOCK = 'forgetPass-block';
export const INTRACK_EVENT_OTP_ERROR = 'forgetPass-otp-error';
